
import { RightOutlined, SearchOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Empty, Form, Input, PageHeader, Row, Select, notification, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import { DATE_FORMAT_DMY_HYPHEN, DATE_FORMAT_DMY_SLASH, GYM_PROGRAM_ID, SUCCESS_STATUS, TAP_PROGRAM_ID, HP_PROGRAM_ID } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from '../../api/programme.service'
import OtherItemsListView from "../../components/otheritem/OtherItemsListView";
import TimeScheduleReport from "./TimeScheduleReport";
import commonService from "../../api/common.service";
import AllReceiptView from "../../components/report/AllReceiptView";
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";

import { PRINT_BASE_URL } from "../../utility/URL";

import moment from 'moment';
const { Option } = Select;

const defaultFormValues = {
    receipt_start_date: commonUtility.firstDateOfMonth("-"),
    receipt_end_date: commonUtility.lastDateOfMonth("-"),
    member_id: "",
};

const ProgrammeDailyCollectionNew = () => {
    const [form] = Form.useForm();

    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [isTapEnable, setIsTapEnable] = useState(false);
    const [isBookingEnable, setIsBookingEnable] = useState(false);
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [programmeList, setProgrammeList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [reportList, setReportList] = useState([]);
    const [programmeGroupList, setProgrammeGroupList] = useState([]);
    const [isGroupEnable, setIsGroupEnable] = useState(false);
    const [isGstDisabled, setIsGstDisabled] = useState(false);



    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            receipt_start_date: dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            receipt_end_date: dateString
        });

    };

    const onReportSearch = async (values) => {
        // console.log('values',values);
        setReportList([])


        //console.log('data',data);

        // ProgrammeService.allReceipt(data).then((res) => {

        //     if (res.data.response_status == SUCCESS_STATUS) {
        //         //  let formatted_data = ConvertedData(res.data);
        //         console.log('res.data',res.data);
        //         setReportList(res.data.response_data);
        //     }
        //     else {
        //         setReportList([])
        //     }
        //     setIsDataUpdated(!isDataUpdated)
        // });


        //btaportal.in/custom/report/print_gst_receipt_reg/01-04-2023/01-04-2013/A/1

        const url_first = 'tap/print_gst_receipt_reg';
        const url_sec = 'gstregister/print_gstreceipt_new';
        let url = buildExcelUrl(values, url_first, url_sec);

        console.log('url', url);
        commonUtility.openInNewTab(url);



    };

    const buildExcelUrl = (values, url_first, url_sec) => {

        let url = '';
        const formdValues = {
            programme_id: values.programme_id == undefined ? '' : values.programme_id,
            //enrollment_id: values.enrollment_id == undefined ? '' : values.enrollment_id,
            //member_id: values.member_id == undefined ? '' : values.member_id,
            from_date: values.receipt_start_date == undefined ? '' : values.receipt_start_date,
            to_date: values.receipt_end_date == undefined ? '' : values.receipt_end_date,
            special_coaching: values.special_coaching == undefined ? '' : values.special_coaching,
            gst_bill: values.gst_bill == undefined ? '' : values.gst_bill,
            group_id: values.group_id == undefined ? '' : values.group_id,
        }

        const data = { formdata: formdValues };

        if (formdValues.from_date != "" && formdValues.from_date != "") {
            if (formdValues.programme_id != "" && formdValues.programme_id == TAP_PROGRAM_ID) {

                if (values.mebership_booking == "B") {
                    url = `${PRINT_BASE_URL}${url_first}/${formdValues.from_date}/${formdValues.to_date}/${formdValues.programme_id}/${values.mebership_booking}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}/${formdValues.special_coaching}/${formdValues.gst_bill}/${formdValues.group_id}`;
                } else {
                    url = `${PRINT_BASE_URL}${url_first}/${formdValues.from_date}/${formdValues.to_date}/${formdValues.programme_id}/${values.mebership_booking}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}/NA/${formdValues.gst_bill}/${formdValues.group_id}`;
                }

            }
            else if (formdValues.programme_id != "" && formdValues.programme_id == GYM_PROGRAM_ID) {
                url = `${PRINT_BASE_URL}${url_first}/${formdValues.from_date}/${formdValues.to_date}/${formdValues.programme_id}/A/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}/NA/${formdValues.gst_bill}/${formdValues.group_id}`;
            } 
            else if (formdValues.programme_id != "" && formdValues.programme_id == HP_PROGRAM_ID) {
                url = `${PRINT_BASE_URL}${url_sec}/${formdValues.from_date}/${formdValues.to_date}/${formdValues.programme_id}/A/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}/NA/${formdValues.gst_bill}/${0}`;
            }
            else {
                url = `${PRINT_BASE_URL}${url_sec}/${formdValues.from_date}/${formdValues.to_date}/${formdValues.programme_id}/A/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}/NA/${formdValues.gst_bill}/${formdValues.group_id}`;
            }
        }

        return url;
    };


    const handleExcelButtonClick = async () => {
        try {
            // Submit form data
            const values = await form.validateFields();
            const url_first = 'tap/excel_gst_receipt_reg';
            const url_sec = 'gstregister/excel_gstreceipt_new';
            let url = buildExcelUrl(values, url_first, url_sec);
            commonUtility.openInNewTab(url);

        } catch (error) {
            console.error('Error:', error);
        }
    };


    const onProgrammeChange = (id, object) => {
        form.setFieldsValue({
            mebership_booking: "",
            group_id: ""
        });

        if (object.short_code == "JCP" || object.short_code == "PF") {
            setIsGroupEnable(true)
            setIsTapEnable(false)
            setIsBookingEnable(false)
            setIsGstDisabled(false)
        }
        else if (object.short_code == "TAP" ) {
            setIsTapEnable(true)
            setIsGroupEnable(false)
            setIsBookingEnable(true)
            setIsGstDisabled(false)
        }
        else if(object.short_code == "GYM"){
            setIsTapEnable(false)
            setIsGroupEnable(false)
            setIsBookingEnable(false)
            setIsGstDisabled(false)
        }
        else if (object.short_code == "HP"){
            setIsGroupEnable(false)
            setIsTapEnable(false)
            setIsBookingEnable(false)
            setIsGstDisabled(false)
        }
        else if (object.short_code == "CNT" || object.short_code == "CN" || object.short_code == "CANTEEN" || object.short_code == "PB" || object.short_code == "PBALL" || object.short_code == "PICKLE BALL" || object.short_code == "PICKLEBALL") {
            setIsTapEnable(false)
            setIsGroupEnable(false)
            setIsBookingEnable(false)
            setIsGstDisabled(true)
            form.setFieldsValue({
                gst_bill: "Y"
            });
        }
        else {
            setIsTapEnable(false)
            setIsGroupEnable(false)
            setIsBookingEnable(false)
            setIsGstDisabled(false)
        }

        //getMemberList(object?.short_code)

        const formattedValues = {
            formdata: {
                programme_id: id,
            },
        };

        console.log("Formatted Values for API Call:", formattedValues);

        ProgrammeService.getDailyCollection(formattedValues)
            .then((res) => {

                if (res.data.response_status === SUCCESS_STATUS) {
                    if (res.data.response_data && res.data.response_data.length > 0) {
                        // Assuming you have a function to handle the data or update the state
                        setProgrammeID(res.data.response_data);
                        console.log("responseData", res);
                    } else {
                        notification.info({
                            message: 'No Data Found',
                            description: 'No data found for the selected programme.',
                        });
                    }
                } else {
                    notification.error({
                        message: 'Error',
                        description: res.data.response_msg,
                    });
                }
            })
            .catch((error) => {
                notification.error({
                    message: 'Error',
                    description: 'Failed to fetch data from the programme component API.',
                });
                console.error("API Error:", error);
            });
    }

    const onMembershipBookingChange = (id, object) => {
        form.setFieldsValue({
            special_coaching: ""
        });
        if (object?.value == "B") {
            setIsBookingEnable(true)
        }
        else {
            setIsBookingEnable(false)
        }
    }

    useEffect(() => {
        ProgrammeService.programmeList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                const programData = res.data.response_data;
                programData.push({
                    is_active: "",
                    is_age_limit: "",
                    is_coaches_fee: "",
                    max_age: null,
                    min_age: null,
                    programme_id: "CA",
                    programme_name: "Club Affiliation",
                    short_code: "CA",
                    short_code_text: "Club Affiliation",
                    type: "PROGRAMME",
                },
                    {
                        is_active: "",
                        is_age_limit: "",
                        is_coaches_fee: "",
                        max_age: null,
                        min_age: null,
                        programme_id: "GR",
                        programme_name: "General Receipt",
                        short_code: "GR",
                        short_code_text: "General Receipt",
                        type: "PROGRAMME",
                    },
                    {
                        is_active: "",
                        is_age_limit: "",
                        is_coaches_fee: "",
                        max_age: null,
                        min_age: null,
                        programme_id: "CNT",
                        programme_name: "Canteen",
                        short_code: "CNT",
                        short_code_text: "Canteen",
                        type: "PROGRAMME",
                    },
                    {
                        is_active: "",
                        is_age_limit: "",
                        is_coaches_fee: "",
                        max_age: null,
                        min_age: null,
                        programme_id: "PB",
                        programme_name: "Pickle Ball",
                        short_code: "PB",
                        short_code_text: "Pickle Ball",
                        type: "PROGRAMME",
                    });
                setProgrammeList([...programData]);
            }
        });

    }, []);

    useEffect(() => {
        const formdValues = {
            member_id: form.getFieldValue('member_id') == undefined ? '' : form.getFieldValue('member_id'),
            receipt_start_date: commonUtility.firstDateOfMonth("-"),
            receipt_end_date: commonUtility.lastDateOfMonth("-"),
        }
    }, [])

    useEffect(() => {
        ProgrammeService.programmeGroupList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeGroupList(res.data.response_data);
            }
        });
    }, []);

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Daily Collection"
                        subTitle=""

                    ></PageHeader>

                    <div className="">



                        <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onReportSearch}
                                    autoComplete="off"
                                    initialValues={defaultFormValues}
                                >

                                    <Row gutter={10} >


                                        <Col xs={24} xl={3} >

                                            <Form.Item name="from_date_picker"
                                                label="From Date"

                                            >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.firstDateOfMonth(), DATE_FORMAT_DMY_HYPHEN)}
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_start_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} >

                                            <Form.Item name="to_date_picker" label="End Date"

                                            >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.lastDateOfMonth(), DATE_FORMAT_DMY_HYPHEN)}
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_end_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        <Col xs={6} xl={4}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select Programme',
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    onSelect={(value, event) =>
                                                        onProgrammeChange(value, event)
                                                    }
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                                short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.short_code_text}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={8} xl={8}>
                                            <Form.Item
                                                name="group_id"
                                                label="Programme Group (Shift)"
                                                rules={[
                                                    {
                                                        required: isGroupEnable,
                                                        message: 'Select Group',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    className="text-left"
                                                    // onSelect={(value, event) =>
                                                    //     onSelectProgrammeGroup(value, event)
                                                    // }
                                                    disabled={!isGroupEnable}
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeGroupList.length > 0
                                                        ? programmeGroupList.map((programme_group_list) => (
                                                            <Option
                                                                key={programme_group_list.programme_group_id}
                                                                value={programme_group_list.programme_group_id}
                                                            >
                                                                {programme_group_list.programme_group}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>


                                        <Col xs={6} xl={4}>
                                            <Form.Item
                                                name="mebership_booking"
                                                label="Membership/Booking"
                                                rules={[
                                                    {
                                                        required: isTapEnable,
                                                        message: 'Select Membership/Booking',
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    onSelect={(value, event) =>
                                                        onMembershipBookingChange(value, event)
                                                    }
                                                    disabled={!isTapEnable}>
                                                    <Option value="A">Membership</Option>
                                                    <Option value="B">Booking</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={6} xl={4}>
                                            <Form.Item
                                                name="special_coaching"
                                                label="Adult/Special Coaching"
                                                rules={[
                                                    {
                                                        required: isBookingEnable,
                                                        message: 'Select Adult/Special Coaching'
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left" disabled={!isBookingEnable}>
                                                    <Option value="TAPM">Adult Coaching</Option>
                                                    <Option value="TAPSC">Special Coaching</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={6} xl={3}>
                                            <Form.Item
                                                name="gst_bill"
                                                label="Bill"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select GST Bill'
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left" disabled={isGstDisabled}>
                                                    <Option value="Y">GST</Option>
                                                    <Option value="N">NON-GST</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1} style={{ marginRight: '50px' }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    className="custom-button-green"
                                                >
                                                    <SearchOutlined /> View
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="button"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    onClick={handleExcelButtonClick}
                                                >
                                                    <DownloadOutlined /> Excel
                                                </Button>
                                            </Form.Item>
                                        </Col>





                                    </Row>
                                </Form>



                            </Col>
                        </Row>


                        {/* <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/> */}

                        {/* <OtherItemsListView /> */}



                        {/* <div className='tableView'>
                            <div className="form-content">
                                <AllReceiptView reportList={reportList} isDataUpdatedValue={isDataUpdated} />
                            </div>
                        </div> */}




                    </div>

                </div>
            </div>

        </div>
    )
}

export default ProgrammeDailyCollectionNew